export default {
  common: {
    nav: {
      home: "Início",
      find_offer_help: "Encontrar / Oferecer ajuda",
      celebrate: "Celebrar uma vida",
      family_tree: "Árvore genealógica",
      events: "Eventos",
      civic_reports: "Relatórios cívicos",
      neighborhood_pulse: "Pulso do bairro",
      weather: "Clima",
      nature: "Natureza",
      marketplace: "Mercado",
      news: "Notícias",
      causes: "Causas",
      more: "Mais",
    },
    header: { sign_in: "Entrar", join: "Junte-se ao Social Pulse", language: "Idioma", search: "Buscar" },
    tagline: "Conectando comunidades · Empoderando vidas · Construindo capital social",
    locality: {
      viewing_from: "Você está vendo de",
      help_improve: "Ajude-nos a melhorar sua localização",
      filter_by_country: "Filtrar por país",
      change: "Alterar",
      set_your_location: "Definir sua localização",
      set_your_location_hint: "— toque para personalizar",
    },
    actions: {
      submit_cause: "Enviar uma causa / pedido",
      make_donation: "Apoie as iniciativas globais do Social Pulse — Faça uma doação",
      browse_all: "Ver todas as seções",
    },
    news: {
      title: "Seu resumo diário.",
      submit_news: "Enviar notícia",
      archive: "Arquivo",
      weather_nature: "Clima e natureza",
      play_briefing: "Reproduzir resumo diário",
      play_briefing_hint: "Ouça as {{count}} principais notícias · ~{{minutes}} min · no seu idioma",
      read_original: "Ler original",
      view_brief: "Ver resumo",
      also_reported_by: "Também noticiado por:",
      translate: "Traduzir",
      listen: "Ouvir",
      stop: "Parar",
    },
  },
};
